import {createStore, applyMiddleware, compose} from 'redux';
import reducers from './reducers';
import reduxReset from 'redux-reset';

const middlewares = [];

const enhanceCreateStore = compose(
    applyMiddleware(...middlewares),
    reduxReset()  // Will use 'RESET' as default action.type to trigger reset
  )(createStore);

const autoMessageStore = enhanceCreateStore(reducers,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

// needs both formats
module.exports = autoMessageStore;
export default autoMessageStore;



// WEBPACK FOOTER //
// ./redux/store.js